import React, { useEffect } from 'react'
import './index.scss'
import Header from '@shared/Header'
import Footer from '@shared/Footer'
import { Container } from 'react-bootstrap'
import ServicesOne from '@assets/images/services-one.jpg'
import ServiceArrowLeft from '@assets/images/left-down-arrow.png'
import ServiceArrowRight from '@assets/images/right-top.png'
import ServicesBgArrow from '@assets/images/services-bg-arrow.png'
import AccordionOne from '@assets/images/accordion-1.jpg'

const Services = () => {
  const [activeAccordion, setActiveAccordion] = React.useState('1')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <Header />
      <div className='services'>
        <Container>
          <div className='pt-5'>
            <h1 className='services-title'>
              Empowering Your Digital Transformation Journey
            </h1>
          </div>
          <div className='services-content'>
            <div className='services-content-item'>
              <div
                className='services-content-item__one'
                style={{ backgroundImage: `url(${ServicesOne})` }}
              >
                <h3>Enabling experts on call</h3>
                <p>
                  Providing Resources and consulting services on call for quick
                  consultation, short-term and long-term engagement.
                </p>
                {/* <img src={ServicesOne} alt='' /> */}
              </div>
            </div>
            <div className='services-content-item'>
              <div className='services-content-item__two'>
                <div className='services-content-item__two-content one'>
                  <h5>Niche Skills Staffing</h5>
                  <p>
                    For innovative technologies such as SAP BTP, SAP S/4Hana,
                    SAP HANA, SAP SCM, Fiori, CDS, ABAP, other non-SAP like
                    DevOps, Oracle, Microsoft, AWS cloud, Blockchain, AI, ML
                    etc., for Long-Term & short term engagement.
                  </p>
                </div>
                <div
                  className='services-content-item__two-content two'
                  style={{ backgroundImage: `url(${ServiceArrowLeft})` }}
                >
                  <h5>Enabling Success for entrepreneurs</h5>
                  <p>
                    Platform for MSME / individual entrepreneurs to offer
                    their resources / consulting service through this platform.
                  </p>
                </div>
                <div
                  className='services-content-item__two-content three'
                  style={{ backgroundImage: `url(${ServiceArrowRight})` }}
                >
                  <h5>Crafting Solutions, Elevating Expertise</h5>
                  <p>
                    Solution Architecture, Domain Excellence, SAP migration
                    services, integration services, mobile apps, POC building,
                    etc.
                  </p>
                  <p>&nbsp;</p>
                </div>
                <div className='services-content-item__two-content four'>
                  <h5>Transforming Tech Talents</h5>
                  <p>
                    Technical training and development on AI, ML, IOT,
                    Blockchain, Edge Solutions, mobile applications, SAP
                    platform solutions, cloud applications, etc
                  </p>
                </div>
              </div>
            </div>
            {/* <div className='services-content-item'>
              <div className='services-content-item__three'>
                <img src={AccordionOne} />
              </div>
            </div> */}
            <div className='services-content-item'>
              <div className='services-content-item__four'>
                {/* Accordion 1 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('1')}
                  >
                    <p>
                      <span>01</span> SAP Platform & Other Technology Services
                    </p>
                    <span>{activeAccordion === '1' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '1' && (
                    <div className='accordion-body'>
                      {/* <p className='accordion-body-text'>
                        <span>SAP AI Enabled Services </span> - We offer Experts who have delivered across a range of SAP AI-enabled solutions including generative AI tools such as <b>Joule</b>,<b>SAP Build Code</b>, <b>AI Core</b>, <b>AI Foundation</b>, <b>machine learning services</b>, and but not limited to <b>SAP Build Process Automation</b> for intelligent process orchestration. With deep expertise across these technologies, our experts help organizations effectively embed AI into their business landscape—driving automation, agility, and measurable impact.
                      </p>

                      <p className='accordion-body-text'>
                        <span>SAP BTP, Integration & Extension</span> – We enable organizations to integrate or extend <strong>SAP Business Technology Platform (BTP)</strong> applications to customize SAP solutions or expand their entire digital landscape. Our experts have hands-on experience with technologies such as <strong>SAP BDC</strong>, <strong>SAP Datasphere</strong>, <strong>BTP CAPM</strong>, <strong>BTP RAP</strong>, and <strong>Side-by-Side Extensions</strong>.

                        Additionally, they bring extensive expertise in the <strong>SAP Integration Suite</strong>, enabling seamless connectivity across SAP and non-SAP systems. They specialize in designing, developing, and deploying robust integration flows using tools like <strong>API Management</strong>, <strong>Cloud Integration (CPI)</strong>, and <strong>Event Mesh</strong>, helping organizations streamline business processes and enhance interoperability across their IT landscape.
                      </p>
                      <p className='accordion-body-text'>
                        <span>Salesforce, Databricks, Snowflake & Business Data Cloud (BDC)</span> – Our experts bring deep domain and technical expertise across leading cloud-based platforms that drive modern enterprise transformation. With <strong>Salesforce</strong>, we help organizations streamline customer engagement and business operations using tools like <strong>Salesforce Flow</strong>, <strong>Apex</strong>, and <strong>Lightning Components</strong>.

                        In the data and analytics space, our team leverages <strong>Databricks</strong> for building scalable data pipelines, performing real-time analytics, and enabling AI/ML-driven insights on a unified data platform. We also specialize in <strong>Snowflake</strong>, empowering businesses with cloud-native data warehousing solutions, secure data sharing, and seamless integration for diverse workloads.

                        Our proficiency in <strong>Business Data Cloud (BDC)</strong> ensures organizations can unlock the full potential of their data by integrating, governing, and scaling their enterprise data environments efficiently — enabling informed decision-making and business agility.
                      </p> */}
                      <p className='accordion-body-text'>
                        <span>SAP AI Enabled Services</span> – We offer experts who have delivered across a range of SAP AI-powered solutions.


                        Our experience includes generative AI tools like <strong>Joule</strong>, <strong>SAP Build Code</strong>, <strong>AI Core</strong>, and <strong>AI Foundation</strong>.


                        We also specialize in <strong>Machine Learning services</strong> and <strong>SAP Build Process Automation</strong> for intelligent workflows.


                        These capabilities help businesses embed AI into their processes—driving automation, agility, and impact.
                      </p>

                      <p className='accordion-body-text'>
                        <span>SAP BTP, Integration, Extension & BDC</span> – We help organizations integrate or extend their SAP landscape using <strong>SAP BTP</strong>.


                        Our team brings expertise in <strong>SAP S/4HANA</strong>, <strong>SAP Datasphere</strong>, <strong>SAP Business Data Cloud (BDC)</strong>, <strong>BTP CAPM</strong>, <strong>BTP RAP</strong>, and <strong>Side-by-Side Extensions</strong>.


                        We also work extensively with the <strong>SAP Integration Suite</strong> for seamless connectivity across SAP and non-SAP systems.
                      </p>


                      <p className='accordion-body-text'>
                        <span>Salesforce, Databricks, Snowflake </span> – We support enterprise cloud transformation with leading platforms.
                        With <strong>Salesforce</strong>, we build CRM solutions using <strong>Flow</strong>, <strong>Apex</strong>, and <strong>Lightning Components</strong>.

                        On <strong>Databricks</strong>, we develop scalable pipelines, real-time analytics, and ML-driven insights.

                        Our <strong>Snowflake</strong> experts modernize data warehousing with secure, cloud-native architecture.

                        And through <strong>Business Data Cloud (BDC)</strong>, we enable integrated, governed, and scalable data environments.
                      </p>

                      <p className='accordion-body-text'>
                        <span>SAP HANA</span> - SAP HANA offers storage, data
                        aging and dynamic tiering, provisioning capabilities,
                        disaster recovery, monitoring tools, data modeling, and
                        an array of security features.
                      </p>

                      <p className='accordion-body-text'>
                        <span>SAP Security</span> - SAP Security guards SAP data
                        and applications from unauthorized use or access at
                        various levels of permission.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 2 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('2')}
                  >
                    <p>
                      <span>02</span> SAP Business Applications
                    </p>
                    <span>{activeAccordion === '2' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '2' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>SAP S/4HANA</span> - Improve your business
                        processes with SAP S/4HANA, an integrated ERP system
                        that uses an in-memory database intelligent automation.
                      </p>
                      <p className='accordion-body-text'>
                        <span>SAP Supply Chain Management</span> - By
                        implementing SAP supply chain management applications,
                        your business can develop customer-centric products more
                        quickly and efficiently.
                      </p>
                      <p className='accordion-body-text'>
                        <span>SAP Ariba</span> - SAP Ariba will keep you updated
                        on financial and operational disruptions, satisfy
                        customer service and workforce needs, as well as reduce
                        supplier risk and market uncertainty.
                      </p>
                      <p className='accordion-body-text'>
                        <span>SAP Concur</span> - SAP Concur connects all
                        expenses and invoices into one system, allowing a single
                        method to manage your budget by obtaining better
                        visibility into transactions and boosting compliance for
                        everyone.
                      </p>
                      <p className='accordion-body-text'>
                        <span>SAP Hybris</span> - SAP Hybris assists sellers in
                        optimizing margins and driving customer loyalty.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 3 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('3')}
                  >
                    <p>
                      <span>03</span> SAP Analytics & Big Data
                    </p>
                    <span>{activeAccordion === '3' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '3' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>SAP Analytics Cloud (SAC)</span> - SAP Analytics
                        Cloud combines analytics and planning in a single
                        solution in the cloud.
                      </p>
                      <p className='accordion-body-text'>
                        <span>SAP MDG</span> - SAP`s MDG solution will enable
                        you to establish, monitor, and improve master data
                        across domains for central or decentralized master data
                        in hybrid landscapes.
                      </p>
                      <p className='accordion-body-text'>
                        <span>SAP DW Cloud</span> - SAP Data Warehouse Cloud
                        offers software solutions to provide businesses with
                        data from data warehousing, data integration, and data
                        analytics.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 4 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('4')}
                  >
                    <p>
                      <span>04</span> SAP Programming
                    </p>
                    <span>{activeAccordion === '4' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '4' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>SAP ABAP RAP</span> - The Remote Application
                        Programming Interface, is a tool that will enable your
                        system administrators and IT professionals to work more
                        efficiently by streamlining their processes and ensuring
                        quality assurance at every step of development.
                      </p>
                      <p className='accordion-body-text'>
                        <span>SSAP Fiori </span> - With SAP Fiori, you can
                        create applications with a highly effective user
                        experience.
                      </p>
                      <p className='accordion-body-text'>
                        <span>SAP UI5</span> - Create online apps that are
                        responsive. Just a single program does everything for
                        your online applications.
                      </p>
                      <p className='accordion-body-text'>
                        <span>SAP Build (Low-Code, No-Code)</span> - Easily
                        build and extend business applications, process
                        automations, or business sites.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  )
}

export default Services
